import { useAuthIsLoaded } from '@/hooks/useAuthIsLoaded';

export interface UseWidgetDataUpdatingOptions {
  isFetching?: boolean;
  isLoading?: boolean;
  /** When true (default), returns true until auth has finished loading. */
  requireAuth?: boolean;
}

/**
 * True while a widget should show a loading/updating placeholder.
 * Covers auth bootstrap, initial RTK Query load, and refetches (e.g. date range change).
 */
export function useWidgetDataUpdating({
  isFetching = false,
  isLoading = false,
  requireAuth = true,
}: UseWidgetDataUpdatingOptions): boolean {
  const authLoaded = useAuthIsLoaded();

  if (requireAuth && !authLoaded) {
    return true;
  }

  return isLoading || isFetching;
}
